import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, SectionHeader } from "./Reveal";

const ARROW_ICON_SIZE = 15;

const cards = [
  {
    title: "Cosmetics",
    href: "/cosmetic-formulation-development",
    text: "Skincare, haircare and personal care formulations built on modern actives, elegant textures and proven stability.",
    img: "https://images.unsplash.com/photo-1773565744218-d8d11de58362?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHx3ZWxsbmVzcyUyMHNwYSUyMGFlc3RoZXRpYyUyMGJlYXV0eSUyMHByb2R1Y3RzfGVufDB8fHx8MTc4NDk5Njk3OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Ayurveda",
    href: "/wellness-product-development",
    text: "Classical and proprietary Ayurvedic products developed by Ayurvedic doctors.",
    img: "https://images.unsplash.com/photo-1636740599648-ae84f705fc2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxsYWJvcmF0b3J5JTIwZ2xhc3N3YXJlJTIwbHV4dXJ5JTIwY29zbWV0aWMlMjBmb3JtdWxhdGlvbnxlbnwwfHx8fDE3ODQ5OTY5Nzh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Nutraceuticals",
    href: "/services",
    text: "Capsules, gummies, powders and functional wellness formats — efficacious, compliant and market-ready.",
    img: "https://images.unsplash.com/photo-1664956618021-73c47736845e?auto=format&fit=crop&q=80&w=1200",
  },
];

export default function Expertise() {
  return (
    <section id="expertise" data-testid="expertise-section" className="py-24 lg:py-32 bg-ivory scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHeader overline="Our Expertise" title={<>Three disciplines. <em className="italic font-medium">One studio.</em></>} />
        <div className="mt-16 grid md:grid-cols-3 gap-8">
          {cards.map(({ title, text, img, href }, i) => (
            <Reveal key={title} delay={i * 0.12} className="group">
              <div className="overflow-hidden rounded-t-[100px] rounded-b-xl h-[380px]">
                <img src={img} alt={title} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
              </div>
              <div className="pt-8">
                <h3 className="font-display text-2xl sm:text-3xl text-navy">{title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/75 max-w-sm">{text}</p>
                <Link
                  to={href}
                  data-testid={`expertise-learn-more-${title.toLowerCase()}`}
                  className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-navy border-b border-navy/30 pb-1 transition-colors duration-300 group-hover:border-navy"
                >
                  Learn More <ArrowRight size={ARROW_ICON_SIZE} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
